<div class="map-widget-container">
  <!-- Map Container -->
  <div class="map-container">
    <div id="map-content" class="map-content"></div>

    <!-- Loading Overlay -->
    @if (loading || !isMapLoaded() && !mapError()) {
      <div class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>{{ 'doktar_app.common.loading' | translate }}</p>
      </div>
    }

    <!-- Error Overlay -->
    <div *ngIf="mapError()" class="error-overlay">
      <div class="error-icon">⚠️</div>
      <p>{{ mapError() }}</p>
      <dk-button
        [label]="'doktar_app.common.retry_button' | translate"
        severity="secondary"
        (onClick)="retryMapLoad()"></dk-button>
    </div>

    <!-- Add Plantation Dialog Overlay -->
    <div *ngIf="!loading && showAddPlantationDialog && isMapLoaded()" class="plantation-dialog-overlay">
      <div class="plantation-dialog">
        <span class="dialog-title">{{ 'doktar_app.home.no_plantations_alert.title' | translate }}</span>
        <span class="dialog-description">{{ 'doktar_app.home.no_plantations_alert.description' | translate }}</span>
        <div class="dialog-buttons">
          <dk-button
            [label]="'doktar_app.common.ignore_button' | translate"
            severity="secondary"
            (onClick)="onIgnorePlantation()"></dk-button>
          <dk-button
            [label]="'doktar_app.home.no_plantations_alert.title' | translate"
            (onClick)="onAddPlantation()"></dk-button>
        </div>
      </div>
    </div>

    <!-- Header Overlay - Top positioned like Figma -->
    <div class="map-header-overlay">
      <!-- Left: Asset Information -->
      <div class="asset-info">
        <span class="asset-title">
          {{ 'doktar_app.home.assets' | translate }}
        </span>
        <span class="asset-summary">
          {{
            'doktar_app.home.assets_info'
              | translate
                : { arg1: assetCounts().landCount, arg2: assetCounts().plantationCount, arg3: assetCounts().totalArea }
          }}
        </span>
      </div>

      <!-- Right: Control Buttons -->
      <div class="map-controls">
        <!-- Device Count Indicators -->
        @if (deviceCounts().length > 0 && !showAddPlantationDialog) {
          <dk-device-count-indicator [devices]="deviceCounts()"></dk-device-count-indicator>
        }
        
        <!-- Filter Button -->
        <dk-button
          [icon]="'ph-fill ph-sliders-horizontal'"
          [label]="'doktar_app.common.filter' | translate"
          (onClick)="toggleFilterModal()"
          severity="secondary"
          [text]="true">
          @if (hasActiveFilters) {
            <span class="filter-badge"></span>
          }
        </dk-button>
        
        <!-- Fullscreen Button -->
        <dk-button
          [icon]="isFullScreen ? 'ph ph-arrows-in-simple' : 'ph ph-arrows-out-simple'"
          (onClick)="toggleFullScreenMode()"
          severity="secondary"
          [text]="true"></dk-button>
      </div>
    </div>
  </div>
</div>
